import Vue from 'vue';
import Router from 'vue-router';

// 登录相关
import forget from '../views/login/forgetPwd';
const envJudge = require('../utils/envJudge');

Vue.use(Router);

export const authRoute = [
  {
    path: '/',
    redirect: '/community'
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test')
  },

  {
    path: '/noAuth',
    name: 'noAuth',
    component: import('../views/notFound/noAuth')
  },
  {
    path: '/noPage',
    name: 'noPage',
    component: import('../views/notFound/noPage')
  },
  {
    path: '/forget',
    name: 'forget',
    component: forget
  }
];

export default new Router({
  base: envJudge(),
  routes: [...authRoute]
});
